import React, { useState, useEffect, useRef, useContext } from "react";
import ReactMarkdown from 'react-markdown';
import styled from "styled-components";
import { Icons, MapControlButton } from "kepler.gl/components";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import "./chat-map-control.css";
import axios from "axios";
import { VscHubot } from "react-icons/vsc";
import { AiOutlineClose, AiOutlineLike, AiOutlineDislike, AiFillLike, AiFillDislike, AiOutlineReload } from "react-icons/ai";
import { BsFillSendFill } from "react-icons/bs";
import { LuCopy, LuCopyCheck, LuFile, LuPlus } from "react-icons/lu";
import { MdAttachFile } from "react-icons/md";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { CodeBlock, dracula } from "react-code-blocks";
import {BouncingDotsLoader, ProgressLoader} from "../loader";
import Plot from 'react-plotly.js';
import { useDispatch } from "react-redux";
import { loadFiles, addDataToMap } from "kepler.gl/actions";
import { processCsvData, processGeojson } from "kepler.gl/processors";
import { AUTH_TOKENS } from "../../constants/default-settings";
import { configureAWS } from "../../constants/aws-configure";
import { uid } from 'uid';
import { AuthContext } from "../../cognito/AuthContext";
import { refreshToken } from "../../cognito/cognitoUtils";
import { chatHistory, chat, deleteChat } from "./chat-history";
import { config } from "aws-sdk";
import pako from "pako";
const hljs = require('highlight.js');
const languages_list = hljs.listLanguages();


// Styled components
const StyledFloatingPanel = styled.div`
  z-index: 10;
  margin-right: 12px;
  margin-top: 20px;
`;

const StyledModal = styled.div`
  background-color: ${(props) => props.theme.panelBackground};
  position: relative;
  width: 100%;
  height: 100%;
`;

const contentStyle = () => ({
  height: "100%",
  width: "90%",
});

export function ChatBotPanel(props) {
  const [input, setInput] = useState("")
  const [data, setData] = useState("");
  const [messages, setMessages] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [isUploading, setUploading] = useState(false)
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [fail, setFail] = useState(false);
  const [copied, setCopied] = useState(false);
  const [files, setFiles] = useState([]);
  const [geometry, setGeometry] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({});
  const [history, setHistory] = useState([]);
  // const [s3, setS3] = useState(null);
  const [abortController, setAbortController] = useState(null); 
  const [temp, setTemp] = useState([])
  const [responses, setResponses] = useState({})
  const [status, setStatus] = useState(null);
  const [ws, setWs] = useState(null);
  const [messageChunks, setMessageChunks] = useState({});
  const [codeVisibility, setCodeVisibility] = useState({});

  const chatId = useRef(uid(6));
  const hiddenFileInput = useRef(null);
  const messagesEndRef = useRef(null);

  const dispatch = useDispatch();

  const s3_bucket = AUTH_TOKENS.S3_BUCKET;
  const prefix = process.env.PREFIX_UPLOAD
  const api_endpoint = process.env.API_ENDPOINT
  const websocket_url = process.env.WEBSOCKET_URL

  const { user, id_token, setIdToken, s3, setS3 } = useContext(AuthContext);

  // useEffect(() => {
  //   console.log(api_endpoint)
  //   console.log("Chat ID:", chatId);
  //   console.log(user)
  // }, []);

  //Fetch chat history.
  const fetchChatHistory = async () => {
    try {
      const chatData = await chatHistory(id_token, user.username);
      setHistory(chatData);
    } catch (error) {
      console.error("Error fetching chat history:", error);
    }
  };

  //Fetch chat
  const fetchChat = async (chat_id) => {
    try {
      chatId.current = chat_id
      // console.log(chatId.current)
      const chatMessage = await chat(id_token, user.username, chat_id)
      setMessages(chatMessage)
      setResponses({})
      for (let message of chatMessage) {
        setResponses((prevResponses) => ({
          ...prevResponses,
          [message.message_id]: message.user_response,
        }));
      }
    } catch (error) {
      console.error("Error fetching chat history:", error);
    }
  };

  useEffect(()=>{
    // console.log('fetch chat')
    fetchChatHistory();  
    fetchChat(chatId.current)  
  },[])

  // useEffect(()=>{
  //   const interval = setInterval(() => {
  //     fetchChatHistory()
  //   },5000);
  //   return () => clearInterval(interval);
  // })

  useEffect(() => {
    const interval = setInterval(() => {
      refreshToken(setIdToken, setS3, id_token)
    }, 5 * 60 * 1000); 
  
    return () => clearInterval(interval); 
  }, []);
  

  // useEffect(() => {
  //   console.log(temp);
  // }, [temp]);

  // useEffect(() => {
  //   console.log(messages);
  // }, [messages]);

  const createAbortController = () => {
    const controller = new AbortController();
    setAbortController(controller);
    return controller;
  };


  //Upload files to S3
  const uploadFile = async (controller) => {
    const urls = [];
    setUploading(true)

    for (const file of files) {
      const params = {
        Bucket: s3_bucket,
        Key: `${prefix}${file.name}`,
        Body: file,
      };

      try {
        const managedUpload = s3.upload(params);

        managedUpload.on("httpUploadProgress", (progress) => {
          if (controller.signal.aborted) {
            managedUpload.abort();
            return;
          }
          const percent = Math.round((progress.loaded / progress.total) * 100);
          setUploadProgress((prevProgress) => ({
            ...prevProgress,
            [file.name]: percent,
          }));
        });

        await managedUpload.promise();
        const url = `${s3_bucket}/${prefix}${file.name}`;
        urls.push(url);
      } catch (error) {
        if (controller.signal.aborted) {
          console.log("Upload interrupted.");
        } else {
          console.error("Error uploading file:", error);
        }
      }
    }

    setFiles([]);
    setUploadProgress({});
    setUploading(false)
    return urls
  };

  //Handle change in text box
  const handleChange = (e) => {
    setInput(e.target.value)
    setData(e.target.value)
  };

  //Handle websocket connection
  const handleSubmit = async (e, regenerate = false, user_input = null) => {
    if (e) e.preventDefault();

    const inputText = user_input ?? data;
    if (!inputText.trim() && !regenerate) {
        console.log("Input is empty or only contains spaces");
        return;
    }

    setInput("");
    setFail(false);
    
    const message_id = uid(16);
    // console.log("Generated message_id:", message_id);

    const controller = createAbortController(); 

    //Create new connection
    if (!ws || ws.readyState !== WebSocket.OPEN) {
        // console.log("WebSocket not connected, reconnecting...");
        const socket = new WebSocket(websocket_url+'?Authorization='+id_token);

        //set timeout for websocket connection
        const timeout = setTimeout(() => {
          console.log("WebSocket connection timed out");
          socket.close();
          setWs(null);
          setFail(true);
        }, 180000);
        
        setWs(socket);

        //Open connection
        socket.onopen = () => {
            clearTimeout(timeout);
            // console.log("WebSocket connected");
            sendWebSocketMessage(socket, inputText, regenerate, message_id, controller);
        };

        //Send message
        socket.onmessage = (event) => {
            clearTimeout(timeout);
            if (controller.signal.aborted) return;  
            // console.log("Message received from server 1:", event.data);
            handleWebSocketResponse(event.data, message_id, controller);
            controller.signal.addEventListener('abort', () => {
              cancelRequest(socket, message_id); // cancel the server job
            });
        };

        //Close connection
        socket.onclose = () => {
          clearTimeout(timeout);
          // console.log("WebSocket disconnected");
        };

        //Handle error in connection
        socket.onerror = (error) => {
            clearTimeout(timeout);
            console.error("WebSocket error:", error);
            setFail(true);
            setWs(null);
        };
    
    //Use opened connection
    } else {
        sendWebSocketMessage(ws, inputText, regenerate, message_id, controller);
        ws.onmessage = (event) => {
            if (controller.signal.aborted) return; 
            // console.log("Message received from server 2:", event.data);
            handleWebSocketResponse(event.data, message_id, controller);
            controller.signal.addEventListener('abort', () => {
              cancelRequest(ws, message_id); // cancel the server job
            });
        };
    }
  };

  //Preparing message before sending
  const sendWebSocketMessage = (socket, inputText, regenerate, message_id, controller) => {
    if (controller.signal.aborted) return; 

    let input = { user_input: inputText, files: [] };

    if (!regenerate) {
        setTemp([inputText]);
        if (files.length) {
            uploadFile(controller).then((urls) => {
                if (controller.signal.aborted) return;  
                input.files = urls;
                setTemp((prevTemp) => [...prevTemp, urls]);
                sendMessage(socket, input, message_id, controller);
            }).catch(err => console.error("File upload error:", err));
        } else {
            sendMessage(socket, input, message_id, controller);
        }
    } else {
        setMessages((prevMessages) => prevMessages.slice(0, -1));
        input.user_input = temp[0];
        if (temp[1]?.length) input.files = temp[1];
        sendMessage(socket, input, message_id, controller);
    }
  };

  //Sending message to api
  const sendMessage = (socket, input, message_id, controller) => {
    if (controller.signal.aborted) return; 

    input.username = user.username;
    input.chat_id = chatId.current;
    input.message_id = message_id;

    const newMessage = {
        sender: "you",
        message_id: message_id,
        text: input.user_input,
        files: input.files,
    };

    setMessages((prevMessages) => [...prevMessages, newMessage]);
    setLoading(true);

    socket.send(JSON.stringify({
        action: "sendMessage",
        chat_id: chatId.current,
        message_id: message_id,
        user_input: input.user_input,
        files: input.files,
        username: user.username,
    }));
  };

  //Handle response
  const handleWebSocketResponse = (data, message_id, controller) => {
    if (controller.signal.aborted) return; 

    try {
        const res = JSON.parse(data);
        // console.log(res);
        if (res.status) setStatus(res.status);
        if (!res.response) return;

        const { chunk_index, total_chunks, chunk_data } = res.response;

        setMessageChunks((prevChunks) => {
            if (controller.signal.aborted) return prevChunks;  

            const isNewMessage = chunk_index === 0;
            const updatedChunks = isNewMessage ? { [chunk_index]: chunk_data } : { ...prevChunks, [chunk_index]: chunk_data };

            if (Object.keys(updatedChunks).length === total_chunks) {
                // console.log("All chunks received, reconstructing message...");
                const fullBase64String = Object.values(updatedChunks).join("");

                try {
                    const binaryString = atob(fullBase64String);
                    const uint8Array = new Uint8Array(binaryString.length);
                    for (let i = 0; i < binaryString.length; i++) {
                        uint8Array[i] = binaryString.charCodeAt(i);
                    }

                    const decompressedData = pako.inflate(uint8Array, { to: "string" });
                    const output = JSON.parse(decompressedData);
                    const data = JSON.parse(output.body);

                    const botMessage = {
                        sender: "bot",
                        message_id: message_id,
                        text: data.output,
                        json: data.json,
                        object: data.file,
                        user_response: null,
                    };
                    // console.log(botMessage)

                    setLoading(false);
                    setMessages((prevMessages) => {
                      const count = prevMessages.filter(msg => msg.message_id === message_id).length;

                      if (count >= 2) {
                          return prevMessages;
                      }

                      // console.log(`Adding message_id: ${message_id}, current count: ${count + 1}`);
                      return [...prevMessages, botMessage];
                  });

                    setGeometry(data.geojson);
                    fetchChatHistory();
                } catch (error) {
                    console.error("Error during decompression:", error);
                }
            }
            return updatedChunks;
        });
    } catch (error) {
        console.error("Error handling WebSocket response:", error);
        setFail(true);
        if (ws) {
            ws.close();
            // console.log("WebSocket connection closed due to an error.");
        }
        setWs(null);
    } finally {
        setData("");
    }
  };


  // Re-generate answer
  const reGenerate = (user_input = null, regenerate = false) => {
    handleSubmit(null, regenerate, user_input)
  }

  //Fetch user feedback
  const userResponse = async (message_id, user_response, like) => {
    const input = {'username': user.username,'chat_id' : chatId.current, 'message_id' : message_id }
    if (responses[message_id] != null && user_response === like){
      // console.log('there is response')
      input["user_response"] = null
    }
    else{
      input["user_response"] = like
    }
    setResponses((prevResponses) => {
      if (prevResponses[message_id] === like) {
        const { [message_id]: _, ...rest } = prevResponses;
        // console.log(rest)
        return rest;
      } else {
        return {
          ...prevResponses,
          [message_id]: like,
        };
      }
    });
    
    const res = await axios.patch(
      api_endpoint + '/user-response',
      input,
      {
        headers: {
            'AUthorization' : id_token,
          }
      }
    );

    // console.log(res)
  };
  

  //Interrupting generate answer 
  const handleInterrupt = () => {
    if (abortController) {
      abortController.abort(); 
      setLoading(false);
      setUploading(false)
      setTemp([])
      setAbortController(null); 
    }
  };

  //Interrupting generate answer in aws lambda
  const cancelRequest = (socket, message_id) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(JSON.stringify({
        action: "cancelAction",
        message_id,
      }));
      console.log(`Cancellation sent for message_id: ${message_id}`);
    }
  };

  //Copy code button
  const handleCopyCode = (code) => {
    navigator.clipboard
      .writeText(code)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
      })
      .catch((err) => console.error("Failed to copy code:", err));
  };

  //Show or hide code
  const toggleCodeVisibility = (id) => {
    setCodeVisibility((prevVisibility) => ({
      ...prevVisibility,
      [id]: !prevVisibility[id],
    }));
  };
  

  //Restrict file size to 100MB.
  const handleFile = (file) => {
    if (file.size > 100 * 1024 * 1024) { 
      // console.log("File size exceeds limit. Maximum size allowed is 100 MB.");
      return false; 
    }
    return true; 
  };

  //Handle selected files.
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files); 
    let validFiles = [];
  
    selectedFiles.forEach((file) => {
      if (validFiles.length < 5 && handleFile(file)) {
        validFiles.push(file);
      }
    });
  
    setFiles((prevFiles) => {
      const totalFiles = [...prevFiles, ...validFiles].slice(0, 5);
      return totalFiles;
    });
  
    e.target.value = ""; 
  };

  //Open file selector
  const handleAttachClick = () => {
    hiddenFileInput.current.click();
  };

  //Clear selected files.
  const clear = (indexToRemove) => {
    setFiles((prevFiles) =>
      prevFiles.filter((_, index) => index !== indexToRemove)
    );
  };
  
  //Download file from link.
  const downloadFile = async (fileName) => {
    const params = {
      Bucket: s3_bucket,
      Key: `${prefix}${fileName}`, 
    };

    s3.getObject(params, (err, data) => {
      if (err) {
        console.error('Error downloading file:', err);
        return;
      }

      const blob = new Blob([data.Body], { type: data.ContentType });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName; 
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url); 
    });
  };

  //Auto-scroll chatbot to bottom.
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, isLoading, isUploading]);

  //Auto-scroll chatbot to bottom.
  useEffect(() => {
    if (isPopupOpen) {
      const timer = setTimeout(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [isPopupOpen]);

  // Block form submission on Shift+Enter.
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <StyledFloatingPanel>
      <Popup
        trigger={
          <MapControlButton title="Click here to submit your data">
            <VscHubot size={18} />
          </MapControlButton>
        }
        modal
        contentStyle={contentStyle}
        nested
        closeOnDocumentClick={false}
        closeOnEscape={false}
        onOpen={() => setPopupOpen(true)}
        onClose={() => setPopupOpen(false)}
      >
        {(close) => {
          const closePopup = () => close();

          //Adding geometry to map
          useEffect(() => {
            try {
              if (geometry && Object.keys(geometry).length > 0) {
                if (geometry.config){
                  dispatch(
                    addDataToMap({
                      datasets: [
                        {
                          info: {
                                label: geometry.config.config.visState.layers[0].config.label,
                                id: geometry.config.config.visState.layers[0].config.dataId
                              },
                          data: processGeojson(geometry.data),
                        },
                      ],
                      config: geometry.config
                    })
                  );
                }
                else{
                  dispatch(
                    addDataToMap({
                      datasets: [
                        {
                          data : processGeojson(geometry.data),
                        }
                      ],
                    })
                  );                  
                }
                {/* console.log("Added data successfully"); */}
                closePopup();
                setGeometry(null);
              }
            } catch (error) {
              setGeometry(null);
            }
          }, [geometry, dispatch]);


          return (
            <StyledModal>
              <div className="modal">

                <div className="side-body">
                  <div className="header-side-body">
                    <p>Chat History</p>
                    <LuPlus 
                    className="new-chat-button" 
                    size={24} 
                    onClick={() => {
                      if(!isLoading){
                        chatId.current = uid(6)
                        fetchChat(chatId.current)
                        setCodeVisibility({})
                      }
                    }}/>
                  </div>
                  <div className="chat-history">
                    {history.map((item, index) => (
                      <div className="chat-id" key={index} 
                        onClick={() => {
                          if (!isLoading) {
                            fetchChat(item.chat_id);
                            setCodeVisibility({})
                          }
                        }}>
                        <p>{item.human_message}</p>
                        <RiDeleteBin6Fill className="delete-chat-button" size={14} 
                        onClick={async (e) => {
                          if(!isLoading) {
                            e.stopPropagation()
                            await deleteChat(id_token, user.username, item.chat_id)
                            fetchChatHistory()
                            chatId.current = uid(6)
                            fetchChat(chatId.current)
                          }
                        }}/>
                      </div>                  
                    ))}
                  </div>
                </div>

                <div className="main-body">
                  <div className="header">
                    <p>Chat Bot</p>
                    <AiOutlineClose
                      className="close-button"
                      size={30}
                      onClick={close}
                    />
                  </div>
                  <div className="content">
                    <div className="message-box">
                      {messages.map((message, index) => (
                        <div
                          key={index}
                          className={`message-box-${message.sender}`}
                        >
                          {message.sender}
                          {message.sender === "you" && message.files != null &&
                              <div className="file-history">
                                { message.files.map((file, index) => (
                                  <div key={index} className="file-uploaded">
                                    <div className="icon-wrapper">
                                      <LuFile size={24} />
                                    </div>   
                                    {file.split("/RAW/temporary_upload/")[1]}                           
                                  </div>
                                ))}
                              </div>
                            }
                          <div className={`message-${message.sender}`}>
                            {message.sender === "bot" &&
                            Object.keys(message.json).length > 0 ? (
                              <div style={{ width: "100%", height: "60vh"}}>
                                <Plot
                                  data={message.json.data}
                                  layout={{ ...message.json.layout, autosize: true }}
                                  style={{ width: "100%", height: "100%" }} // Apply CSS styles
                                />
                              </div>
                            ) : null}    
                            {message.text
                            .split(/(```[\s\S]*?```)/)
                            .map((segment, i) => {
                              if (segment.startsWith("```") && segment.endsWith("```")) {
                                const codeContent = segment.slice(3, -3).trim();
                                if (codeContent === "") {
                                  // If the code block is empty, render it as plain text or skip rendering
                                  return <ReactMarkdown key={'block-' + i}>{segment}</ReactMarkdown>;
                                }
                                const [firstLine, ...codeLines] = codeContent.split("\n");
                                const language = firstLine.trim();
                                const code = codeLines.length > 0 ? codeLines.join("\n") : language;
                                const snippetId = `${index}-${i}`;

                                return (
                                  <React.Fragment key={'block-' + i}>
                                    {languages_list.includes(language) ? (
                                      <div
                                        style={{
                                          position: "relative",
                                          width: "100%",
                                          marginBottom: "10px",
                                          overflowWrap: "break-word",
                                          wordWrap: "break-word",
                                          wordBreak: "break-word",
                                          display: "inline-block",
                                        }}
                                      >
                                        <pre className="code-snippets">
                                          <div className="header-code-snippets">
                                            {language && <div>{language}</div>}
                                            <div className="code-snippets-button">
                                              <button
                                                onClick={() => toggleCodeVisibility(snippetId)}
                                                className="hide-code-button"
                                              >
                                                {codeVisibility[snippetId] ? 'Hide' : 'Show'}
                                              </button>
                                              <button
                                                onClick={() => handleCopyCode(code)}
                                                className="copy-code-button"
                                              >
                                                {copied ? (
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      justifyContent: "center",
                                                    }}
                                                  >
                                                    copied! <LuCopyCheck size={18} />
                                                  </div>
                                                ) : (
                                                  <LuCopy size={18} />
                                                )}
                                              </button>
                                            </div>                                            
                                          </div>
                                          {codeVisibility[snippetId] && (
                                            <div className="body-code-snippets">
                                              <CodeBlock
                                                text={code}
                                                language={language}
                                                theme={dracula}
                                              />
                                            </div>
                                          )}
                                        </pre>
                                      </div>
                                    ) : (
                                      <ReactMarkdown>{code}</ReactMarkdown>
                                    )}
                                  </React.Fragment>
                                );
                              } else {
                                return <ReactMarkdown key={'block-' + i}>{segment}</ReactMarkdown>;
                              }
                            })}
                            {message.sender === "bot" && message.object && <div className="download-link" onClick={() => downloadFile(message.object)}>{message.object}</div>}
                          </div>
                          {message.sender === "bot" &&
                          <div className="action-chat-button">
                            <div className="regerenate-icon" onClick={() => {!isLoading && reGenerate(messages[index-1].text)}}>
                              <AiOutlineReload size={20}/>
                            </div>
                            <div className="like-icon" onClick={() => userResponse(message.message_id, responses[message.message_id], true)}>
                              {responses[message.message_id] ? <AiFillLike size={20}/> : <AiOutlineLike size={20}/>}
                            </div>
                            <div className="dislike-icon" onClick={() => userResponse(message.message_id, responses[message.message_id], false)}>
                              {responses[message.message_id] === false ? <AiFillDislike size={20}/> : <AiOutlineDislike size={20}/>}
                            </div>
                          </div>
                          }
                        </div>
                      ))}                      
                      {isLoading && <BouncingDotsLoader />}              
                      {isLoading && <p className="bot-status">{status}</p>}        
                      {fail && 
                      <div 
                        className="regenerate-button" 
                        onClick={reGenerate(null, true)}>
                        regenerate
                      </div>}
                      <div ref={messagesEndRef} />
                    </div>
                    {files.length !== 0 && (
                      <div className="file-area">
                        {files.map((file, index) => (
                          <div key={index} className="file">
                            {/* <div className='tooltiptext'>{item.name}</div> */}
                            <div className="file-name">{file.name}</div>
                            <div className="clear-file">
                            {  isUploading ? <ProgressLoader progress={uploadProgress[file.name] || 0}/> : 
                              <AiOutlineClose
                                className="close-button"
                                size={18}
                                onClick={() => clear(index)}
                              />
                            }
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    <form onSubmit={handleSubmit}>
                      <div
                        className="attach-file-button"
                        onClick={() => {
                          if (!(isLoading || isUploading)) {
                            handleAttachClick();
                          }
                        }}
                      >
                        <MdAttachFile className="attach-file-button" size={30} />
                      </div>
                      <input
                        type="file"
                        ref={hiddenFileInput}
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                        multiple 
                        accept=".txt, .csv, .json, .geojson, .pdf"
                      />
                      <textarea
                        className="textarea-question"
                        placeholder={(isLoading || isUploading) ? "Waiting..." : "Ask me"}
                        value={input}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        disabled={(isLoading || isUploading)}
                      />
                      <div
                        className="submit-container"
                        onClick={() => {
                          if (!(isLoading || isUploading)) {
                            document.getElementById("submit-input").click();
                          }
                          else{
                            handleInterrupt()
                          }
                        }}
                      >
                      {!(isLoading || isUploading) ? <BsFillSendFill size={30} /> : <AiOutlineClose size={30}/>}
                        <input
                          type="submit"
                          id="submit-input"
                          style={{ display: "none" }}
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </StyledModal>
          );
        }}
      </Popup>
    </StyledFloatingPanel>
  );
}
